/* istanbul ignore file */
import { CreatePageLayout } from 'framework/ui/layout';
import { CreateForm } from 'framework/form';
import { useEmployeeContractUrl } from 'domain/people/employee/contracts/employeeContractRouting';
import useEmployeeContractsService from 'domain/people/employee/contracts/shared/employeeContractsService';
import EmployeeContractForm from 'domain/people/employee/contracts/createupdate/EmployeeContractForm';
import useContractsErrorMap from 'domain/people/employee/contracts/errorHandlers';
import ContractNotStrictRulesHandler from 'domain/people/employee/contracts/shared/ContractNotStictRulesHandler';
import { useShowContext } from 'framework/show';
import { useCacheService } from 'framework/cache';
import { EMPLOYEES_PATH } from 'domain/shared/employee';
import { FormFieldsData } from 'framework/form';
import useContractPositionSlotValidation from '../useContractPositionSlotValidation';

const CreateEmployeeContract = () => {
  const { getListUrl } = useEmployeeContractUrl();
  const { create, getValidationSchema } = useEmployeeContractsService();
  const errorsMap = useContractsErrorMap();
  const { data } = useShowContext();
  const { invalidateCache } = useCacheService(EMPLOYEES_PATH);
  const employeeAlias = data.alias;
  const positionSlotId = (data?.getValueBySource?.('positionSlotId') as string | null) ?? data.positionSlotId ?? null;
  const { validateAndSubmit, validationWarningModal } = useContractPositionSlotValidation({
    employeeAlias,
    positionSlotId,
  });

  const handleSubmit = (values: FormFieldsData) => validateAndSubmit(values, () => create(values));

  return (
    <CreateForm
      submitFormFunc={handleSubmit}
      initialData={{
        hasProbationPeriod: true,
        isIndefinite: false,
      }}
      afterSubmit={{
        redirect: getListUrl(),
        message: 'You are awesome! The Contract has been successfully created.',
        execute: () => {
          invalidateCache();
        },
      }}
      getValidationSchemaFunc={getValidationSchema}
      errorsMap={errorsMap}
    >
      <ContractNotStrictRulesHandler errorMap={errorsMap} />
      <CreatePageLayout title="Create: Contract" titleVariant="h4">
        <EmployeeContractForm isCreateForm employeeAlias={employeeAlias} />
      </CreatePageLayout>
      {validationWarningModal}
    </CreateForm>
  );
};

export default CreateEmployeeContract;
